import React, { useState } from "react";
import ph_phone_call_light from "../assets/icons/ph_phone_call_light.png";
import circum_mail from "../assets/icons/circum_mail.png";
import ph_whatsapp_logo_thin from "../assets/icons/ph_whatsapp_logo_thin.png";
import EmailModal from "./modals/EmailModal";
import TaskCompletedModal from "./modals/TaskCompletedModal";
import RescheduleTaskModal from "./modals/RescheduleTaskModal";
import RescheduleSuccess from "./modals/RescheduleSuccess";
import EditEmailTemplate from "./modals/EditEmailTemplate";

const UserInfoRow = ({
  userImg,
  name,
  mobileNumber,
  email,
  lastInteracted,
  company,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showTaskCompleted, setShowTaskCompleted] = useState(false);
  const [showRescheduledTask, setShowRescheduledTask] = useState(false);
  const [showRescheduleSuccess, setShowRescheduleSuccess] = useState(false);
  const [showEditEmailModal, setShowEditEmailModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setShowTaskCompleted(false);
    setShowRescheduledTask(false);
  };

  return (
    <div className="flex items-center text-[14px] mt-4 mb-4 w-full overflow-auto">
      <div className="flex items-center w-[16rem]">
        <div>
          <img
            src={userImg}
            alt="user image"
            className="w-[40px] rounded-full mr-2"
          />
        </div>
        <div className="font-bold">{name}</div>
      </div>
      <div className="w-[12rem]">+91 {mobileNumber}</div>
      <div className="w-[15rem]">{email}</div>
      <div className="w-[12rem]">{lastInteracted}</div>
      <div className="w-[12rem]">{company}</div>
      <div className="flex mr-4">
        <div className="mr-4 cursor-pointer w-full">
          <img src={ph_phone_call_light} className="w-7" alt="phone" />
        </div>
        <div
          className="mr-4 cursor-pointer w-full"
          onClick={() => setShowModal(true)}
        >
          <img src={circum_mail} className="w-7" alt="mail" />
        </div>
        <div className=" cursor-pointer w-full">
          <img src={ph_whatsapp_logo_thin} className="w-7" alt="whatsapp" />
        </div>
      </div>
      {showModal && (
        <EmailModal
          closeModal={closeModal}
          setShowModal={setShowModal}
          setShowTaskCompleted={setShowTaskCompleted}
          setShowRescheduledTask={setShowRescheduledTask}
          setShowEditEmailModal={setShowEditEmailModal}
        />
      )}
      {showTaskCompleted && <TaskCompletedModal closeModal={closeModal} />}
      {showRescheduledTask && (
        <RescheduleTaskModal
          closeModal={closeModal}
          setShowModal={setShowModal}
          setShowTaskCompleted={setShowTaskCompleted}
          setShowRescheduledTask={setShowRescheduledTask}
          setShowRescheduleSuccess={setShowRescheduleSuccess}
        />
      )}
      {showRescheduleSuccess && (
        <RescheduleSuccess
          closeModal={closeModal}
          setShowRescheduleSuccess={setShowRescheduleSuccess}
        />
      )}
      {showEditEmailModal && (
        <EditEmailTemplate
          setShowEditEmailModal={setShowEditEmailModal}
          setShowRescheduledTask={setShowRescheduledTask}
        />
      )}
    </div>
  );
};

export default UserInfoRow;
